
export const convertElevationToStage = (elevation, gaugeDatum) => { 
  return elevation - gaugeDatum;
}; 

export const convertStageToElevation = (stage, gaugeDatum) => { 
  return stage + gaugeDatum;
};